import Htmllogo from '../images/CRMS.png';
import { Link } from 'react-router-dom';

function Products() {
  return (
    <div>
      <div className='flex-ourtechnologies'>        
        <Link to="/Crms" className='flex-ourtechnologies-images'>
          <img src={Htmllogo} alt='htmllogo' />
          <p>CRM</p>
        </Link>
      </div>
    </div>
  );
}

export default Products;